import { render } from "./SideCardContainer.vue?vue&type=template&id=876477ea&scoped=true"
import script from "./SideCardContainer.vue?vue&type=script&lang=js"
export * from "./SideCardContainer.vue?vue&type=script&lang=js"

import "./SideCardContainer.vue?vue&type=style&index=0&id=876477ea&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-876477ea"]])

export default __exports__